import React from "react";


import { connect } from "react-redux";
import HeaderAgentDetails from "./HeaderAgentDetails";
import HeaderConsumer from "./HeaderProfile";
import HeaderProfile from "./HeaderConsumer";
class Header extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }

    render(){
  
    return(
    <div class="row">
        <HeaderConsumer />
        <HeaderAgentDetails/>
        <HeaderProfile/>
    </div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(Header);
